import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CpfService {
  private readonly API = `${environment.API}`
  constructor(private http: HttpClient) { }

  buscarCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
    if(cpf != "") {
      const validaCPF = /^[0-9]{11}$/;
      if(validaCPF.test(cpf)) {
        return this.http.get(`${this.API}doador/buscarCPF/${cpf}`).pipe(
          take(1)
        )
      }
    }
    return of({});
  }
}
